import React from 'react'
import PropTypes from 'prop-types'

import { currencyFormat } from 'utils/format'
import { dateToBR } from 'utils/date'

import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Checkbox } from 'ui-components/Checkbox'
import { Pending } from './styles'

export default function Debts(props) {
  const {
    debts,
    selectedDebts,
    onSelect,
    onDeselect,
  } = props

  const wasSelected = (id) => {
    const selected = selectedDebts.filter((item) => Number(item.id) === Number(id))
    return Boolean(selected.length)
  }

  const handleCheckboxClick = (debt) => (event) => {
    const { checked } = event.target

    if (checked) return onSelect(debt)
    return onDeselect(debt)
  }

  const renderDebt = (debt) => (
    <Pending key={`debt-${debt.id}`}>
      <DescItemInfo label="">
        <Checkbox
          checked={wasSelected(debt.id)}
          color="primary"
          onChange={handleCheckboxClick(debt)}
        />
      </DescItemInfo>
      <DescItemInfo label="Data">
        {dateToBR(debt.attributes?.date)}
      </DescItemInfo>
      <DescItemInfo label="Número">
        {debt.attributes.code}
      </DescItemInfo>
      <DescItemInfo label="Valor R$">
        {currencyFormat(debt.attributes?.value)}
      </DescItemInfo>
    </Pending>
  )

  return !debts.length ? null : (
    <div>
      <h4>Lista de débitos pendentes</h4>
      { debts.map(renderDebt) }
    </div>
  )
}

Debts.propTypes = {
  debts: PropTypes.arrayOf(PropTypes.object),
  selectedDebts: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func.isRequired,
  onDeselect: PropTypes.func.isRequired,
}

Debts.defaultProps = {
  debts: [],
  selectedDebts: [],
}
